<template>
  <div class="wrapper mt-5 mb-5 pb-5 page-single-product">
    <div class="container">
      <div class="row">
        <div class="col-12 my-4 mt-md-0 order-2 order-md-1">
          <div v-if="product">
            <ProductAlert
              :showDismissibleAlert="showDismissibleAlert"
              :product="product"
            />
          </div>
          <div class="product-header">
            <Breadcrumbs />
            <div v-if="product">
              <h1 class="product-name mb-3 text-black text-uppercase">{{ product.name }}</h1>
              <b-link @click="$router.back()" style="text-decoration: underline;">&lt; {{ $t("view_everything_from_the_category") }}</b-link>
            </div>
          </div>
        </div>
        <div class="w-100 order-md-2" v-if="product"></div>
        <ProductGallery
            v-if="product && product.media_gallery.length > 0"
            @changeIsInWishList="UpdateIsInWishList"
            :images="product.media_gallery"
            :isInWishList="
              $store.getters['user/isProductInWishlist'](product.sku)
            "
          />
          <ProductGallery
            v-if="product && product.media_gallery.length == 0"
            @changeIsInWishList="UpdateIsInWishList"
            :images="[product.image]"
            :isInWishList="
              $store.getters['user/isProductInWishlist'](product.sku)
            "
          />
          <ProductParameters
            @changeIsInWishList="UpdateIsInWishList"
            v-if="product && product.__typename != 'BundleProduct' && product && product.__typename != 'GroupedProduct'"
            :isInWishList="
              $store.getters['user/isProductInWishlist'](product.sku)
            "
          />
          <ProductParametersBundle
            v-if="product && product.__typename == 'BundleProduct'"
            @changeIsInWishList="UpdateIsInWishList"
            :isInWishList="
              $store.getters['user/isProductInWishlist'](product.sku)
            "
          />
          <ProductParametersGrouped
            v-if="product && product.__typename == 'GroupedProduct'"
            @changeIsInWishList="UpdateIsInWishList"
            :isInWishList="
              $store.getters['user/isProductInWishlist'](product.sku)
            "
          />
      </div>
      <DescriptionTab v-if="product" />
      <div class="offers product-detail-offer-slider my-5 py-5 pb-0" v-if="inActionProducts.length">
        <h2 class="section-heading"><span>{{ $t("offers") }}</span></h2>
        <div class="product-grid product-grid-carousel">
          <MoreProductsCarousel :products="inActionProducts" />
          <div class="swiper-button-prev swiper-nav-round offers-swiper-button-prev"></div>
          <div class="swiper-button-next swiper-nav-round offers-swiper-button-next"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs2.vue";
import ProductAlert from "@/esf_antarctica_lederhosenland/core/components/product-detail/ProductAlert.vue";
import ProductGallery from "@/esf_antarctica_lederhosenland/core/components/product-detail/ProductGallery.vue";
import ProductParameters from "@/esf_antarctica_lederhosenland/core/components/product-detail/ProductParameters.vue";
import ProductParametersBundle from "@/esf_antarctica_lederhosenland/core/components/product-detail/ProductParametersBundle.vue";
import ProductParametersGrouped from "@/esf_antarctica_lederhosenland/core/components/product-detail/ProductParametersGrouped.vue";
import DescriptionTab from "@/esf_antarctica_lederhosenland/core/components/product-detail/DescriptionTab.vue";
import MoreProductsCarousel from "@/esf_antarctica_lederhosenland/core/components/product-detail/MoreProductsCarousel.vue";
import { Logger } from "@storefront/core/lib/logger";
/*import DynamicForms from "@/esf_antarctica_lederhosenland/core/components/common/DynamicForms.vue";*/
import { isServer } from "@storefront/core/helpers";
/*import ProductReview from "@/esf_antarctica_lederhosenland/core/components/product-detail/ProductReview.vue";
import CompareButton from "@/esf_antarctica_lederhosenland/core/components/common/CompareButton.vue";*/

import config from "@config";
export default {
  name: "ProductPage",
  components: {
    Breadcrumbs,
    ProductGallery,
    ProductParameters,
    ProductParametersBundle,
    ProductParametersGrouped,
    DescriptionTab,
    MoreProductsCarousel,
    ProductAlert,
    /*DynamicForms,
    ProductReview,
    CompareButton,*/
  },

  computed: {
    ...mapGetters({
      product: "product/getCurrentProduct",
      related: "product/getRelated",
    }),

    showDismissibleAlert() {
      return false;
    },
    productForm() {
      return this.$store.getters["forms/getProductForm"];
    },
    getGTMItems() {
      let items = {
        item_name: this.product.name,
        item_id: this.product.sku,
        quantity: this.quantity,
        price: this.regularPrice,
        item_brand: this.productBrand,
        discount: this.regularPrice - this.finalPrice,
      };
      return items;
    },
    finalPrice() {
      if (this.product && this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.final_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.final_price.value !=
          this.product.price_range.maximum_price.final_price.value
        ) {
          return (
            this.product.price_range.minimum_price.final_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.final_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.final_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.final_price.value !=
        this.product.price_range.maximum_price.final_price.value
      ) {
        return (
          this.product.price_range.minimum_price.final_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.final_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.final_price.value.toFixed(
        2
      );
    },
    regularPrice() {
      if (this.product && this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.regular_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.regular_price.value !=
          this.product.price_range.maximum_price.regular_price.value
        ) {
          return (
            this.product.price_range.minimum_price.regular_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.regular_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.regular_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.regular_price.value !=
        this.product.price_range.maximum_price.regular_price.value
      ) {
        return (
          this.product.price_range.minimum_price.regular_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.regular_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.regular_price.value.toFixed(
        2
      );
    },
    inActionProducts() {
      return this.$store.getters["home/getInActionProducts"];
    },
  },

  watch: {
    product() {
      if (!isServer) {
        if (this.$gtm.enabled()) {
          if (!this.$gtm.uaDisabled) {
            //GA event
            window.dataLayer.push({
              event: "eec.detail",
              ecommerce: {
                detail: {
                  currency: "EUR",
                  value: this.finalPrice,
                  products: [
                    {
                      name: this.product.name,
                      id: this.product.sku,
                      price: this.regularPrice,
                      discount: this.regularPrice - this.finalPrice,
                    },
                  ],
                },
              },
            });
          }
          if (this.$gtm.ga4Enabled) {
            window.dataLayer.push({
              event: "view_item",
              currency: "EUR",
              value: this.finalPrice,
              items: [this.getGTMItems],
            });
          }
        }
      }
    },
  },
  methods: {
    UpdateIsInWishList() {
      if (this.$store.getters["user/getIsLoggedIn"] == true) {
        if (
          this.$store.getters["user/isProductInWishlist"](this.product.sku) ==
          true
        ) {
          this.$store.dispatch("user/setProductWishlistStatus", {
            sku: this.product.sku,
            parentSku: null,
          });
        } else {
          if (this.product && this.product.__typename == "SimpleProduct") {
            this.$store.dispatch("user/setProductWishlistStatus", {
              sku: this.product.sku,
              parentSku: null,
            });
          } else {
            const retval = this.$store.getters["product/getCurrentChildSku"];
            if (retval == null) {
              const msg = {
                type: "danger",
                title: this.$t("wishlist error"),
                text: this.$t("wishlist_select_options"),
              };
              this.$store.dispatch("messages/sendMessage", { message: msg });
              //this.$router.push("/" + this.product.url_key);
            } else {
              Logger.debug(
                "ChildSku",
                "Product.vue",
                this.$store.getters["product/getCurrentChildSku"]
              )();
              Logger.debug("Sku", "Product.vue", this.product.sku)();
              this.$store.dispatch("user/setProductWishlistStatus", {
                sku: this.$store.getters["product/getCurrentChildSku"],
                parentSku: this.product.sku,
              });
            }
          }
        }
      } else {
        const msg = {
          type: "danger",
          title: this.$t("wishlist error"),
          text: this.$t("wishlist_logged_in"),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
      }
    },
  },
  data() {
    return {};
  },
  metaInfo() {
    return {
      meta: [
        { name: "title", content: this.product ? this.product.meta_title : "" },
        {
          name: "keywords",
          content: this.product ? this.product.meta_keyword : "",
        },
        {
          name: "description",
          content: this.product ? this.product.meta_description : "",
        },
        { property: "og:type", content: "product" },
        {
          property: "og:title",
          content: this.product ? this.product.meta_title : "",
        },
        {
          property: "og:image",
          content: this.product ? this.product.image.url : "",
        },
        {
          property: "og:description",
          content: this.product ? this.product.meta_description : "",
        },
        {
          property: "product:price:amount",
          content: this.product
            ? this.product.price_range.minimum_price.final_price.value
            : "",
        },
        {
          property: "product:price:currency",
          content: "EUR",
        },
      ],
      //test 3
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.product ? this.product.name : "",
      link: [
        {
          rel: "canonical",
          href:
            config.app_url +
            "/" +
            (this.product ? this.product.canonical_url : this.$route.fullPath),
        },
      ],
    };
  },
  mounted() {
    if (!isServer) {
      if (this.$gtm.enabled()) {
        if (!this.$gtm.uaDisabled) {
          //GA event
          window.dataLayer.push({
            event: "eec.detail",
            ecommerce: {
              detail: {
                currency: "EUR",
                value: this.finalPrice,
                products: [
                  {
                    name: this.product.name,
                    id: this.product.sku,
                    price: this.regularPrice,
                    discount: this.regularPrice - this.finalPrice,
                  },
                ],
              },
            },
          });
        }
        if (this.$gtm.ga4Enabled) {
          window.dataLayer.push({
            event: "view_item",
            currency: "EUR",
            value: this.finalPrice,
            items: [this.getGTMItems],
          });
        }
      }
    }
  },
};
</script>

<style lang="scss">
</style>
